export default __webpack_public_path__ + "static/portfolio-details-left-2b615b0137cf8d31a8bec2bfc44e5fe3.jpg";